import { Link } from "react-router-dom";
import { Facebook, Instagram, Mail } from "lucide-react";
import LogoMark from "@/components/LogoMark";
import { NAV_LINKS, BRAND } from "@/lib/site";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer className="relative border-t border-white/10 bg-coal/40">
            <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 sm:py-20">
                <div className="flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between">
                    <div>
                        <p className="font-script text-4xl sm:text-5xl text-neon-pink neon-pink-text animate-flicker">
                            let's stay connected!
                        </p>
                        <a
                            data-testid="footer-email-link"
                            href={`mailto:${BRAND.email}`}
                            className="mt-4 inline-block font-display text-lg sm:text-2xl font-600 text-silver transition-colors hover:text-neon-pink"
                        >
                            {BRAND.email}
                        </a>
                    </div>
                    <div className="flex items-center gap-3" data-testid="footer-social-links">
                        <a
                            data-testid="footer-facebook-link"
                            href={BRAND.facebookUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Facebook"
                            className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-silver transition-all hover:border-neon-pink hover:text-neon-pink hover:neon-box-pink"
                        >
                            <Facebook className="h-4.5 w-4.5" size={18} />
                        </a>
                        <a
                            data-testid="footer-instagram-link"
                            href={BRAND.instagramUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                            className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-silver transition-all hover:border-neon-pink hover:text-neon-pink hover:neon-box-pink"
                        >
                            <Instagram size={18} />
                        </a>
                        <a
                            data-testid="footer-mail-icon-link"
                            href={`mailto:${BRAND.email}`}
                            aria-label="Email"
                            className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-silver transition-all hover:border-neon-pink hover:text-neon-pink hover:neon-box-pink"
                        >
                            <Mail size={18} />
                        </a>
                    </div>
                </div>

                <div className="mt-14 grid gap-10 border-t border-white/10 pt-10 sm:grid-cols-3">
                    <div>
                        <div className="flex items-center gap-2.5">
                            <LogoMark size={30} />
                            <div className="leading-tight">
                                <p className="font-display text-sm font-700 uppercase tracking-wide text-silver" style={{ fontWeight: 700 }}>
                                    Checking In
                                </p>
                                <p className="font-script text-base text-neon-pink">
                                    with Courtnie Baby Johnson
                                </p>
                            </div>
                        </div>
                        <p className="mt-4 max-w-xs text-sm leading-relaxed text-fog">
                            A Twin Cities community media platform built on one
                            simple belief: every person has a story worth
                            telling.
                        </p>
                    </div>
                    <div>
                        <p className="eyebrow">Explore</p>
                        <ul className="mt-4 space-y-2.5">
                            {NAV_LINKS.slice(1, 6).map((link) => (
                                <li key={link.path}>
                                    <Link
                                        to={link.path}
                                        className="text-sm text-fog transition-colors hover:text-neon-pink"
                                    >
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <p className="eyebrow">Reach out</p>
                        <ul className="mt-4 space-y-2.5 text-sm text-fog">
                            <li>
                                <a
                                    className="transition-colors hover:text-neon-pink"
                                    href={`mailto:${BRAND.email}`}
                                >
                                    {BRAND.email}
                                </a>
                            </li>
                            <li>FB &amp; IG · {BRAND.facebook}</li>
                            <li>{BRAND.city}</li>
                        </ul>
                    </div>
                </div>

                <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center">
                    <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-fog">
                        Support local · Support live music · Support each other
                    </p>
                    <p className="text-xs text-fog/70">
                        © {year} Checking In with Courtnie Baby Johnson
                    </p>
                </div>
            </div>
        </footer>
    );
}
